import React from "react";
import memoize from "memoize-one";
export const SelectedPanelContext = React.createContext({});
export function SelectedPanelContextProvider(props) {
    const setSelectedPanel = (panel) => {
        let params = {
            selectedPanel: serializeSelectedPanel(panel),
        };
        if ("path" in panel) {
            params = Object.assign(Object.assign({}, params), { path: panel.path });
        }
        if ("viewArgs" in panel) {
            params = Object.assign(Object.assign({}, params), { viewArgs: panel.viewArgs });
        }
        props.setParams(params);
    };
    const selectedPanel = deserializeSelectedPanel(props.params.selectedPanel);
    return (React.createElement(SelectedPanelContext.Provider, { value: { setSelectedPanel, selectedPanel } },
        " ",
        props.children));
}
export const serializeSelectedPanel = memoize((selectedPanel) => {
    if ("position" in selectedPanel) {
        return `${selectedPanel.id}_${selectedPanel.position}`;
    }
    else {
        return `${selectedPanel.id}`;
    }
});
export const deserializeSelectedPanel = memoize((selectedPanel) => {
    if (!selectedPanel)
        return { id: undefined };
    const parts = selectedPanel.split("_");
    if (!isNaN(parseInt(parts[1]))) {
        return { id: parts[0], position: parseInt(parts[1]) };
    }
    else {
        return { id: selectedPanel };
    }
});
//# sourceMappingURL=SelectedPanel.js.map